import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatAutocompleteModule, MatButtonModule, MatCheckboxModule, MatDialogModule, MatIconModule, MatProgressBarModule, MatRadioModule } from '@angular/material';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '@app/shared';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { AssignedToModalComponent } from '@modules/sales/components/lead-notes/assigned-to-modal.component';
import { BookAppoinmentModalComponent } from '@modules/sales/components/lead-notes/book-appoinment-modal.component';
import { EmailModalComponent } from '@modules/sales/components/lead-notes/email-modal.component';
import { ScheduleCallbackAddEditModalComponent } from '@modules/sales/components/lead-notes/schedule-callback-add-edit-modal.component';
import { SMSModalComponent } from '@modules/sales/components/lead-notes/sms-modal.component';
import { SalesDashboardComponent } from '@sales/components/dashboard';
import { ChangeStatusModalComponent } from '@sales/components/raw-lead';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { LayoutModule } from '../../shared/layouts/layout.module';
import { CustomerCallModalComponent, LeadNoteModalComponent } from './components/lead-notes';
import { AuthenticationGuard as AuthGuard } from '@app/shared/services/authguards/can-activate-route.authguard';
import { CustomerContactDetailsModule } from './components/lead-notes/customer-contact.module';

const routes: Routes = [
  { path: 'dashboard', component: SalesDashboardComponent, data: { title: 'Sales Dashboard' } },
  { path: 'unqualified-lead', loadChildren: () => import('../sales/components/raw-lead/raw-lead.module').then(m => m.RawLeadModule) },
  { path: 'task-management', loadChildren: () => import('../sales/components/task-management/task-management.module').then(m => m.TaskManagementModule) },
  { path: 'stop-and-knock', loadChildren: () => import('../sales/components/stop-and-knock/stop-and-knock.module').then(m => m.StopAndKnockModule) },
  { path: 'reward-partnerships', loadChildren: () => import('../sales/components/reward-criteria/reward-criteria.module').then(m => m.RewardCriteriaModule) },
  { path: 'new-address-approval', loadChildren: () => import('../sales/components/raw-lead-new-address-request/raw-lead-new-address-request.module').then(m => m.RawLeadNewAddressRequestModule) },
  { path: 'marketing-data', loadChildren: () => import('../sales/components/markating-data-sync-dashboard/markating-data-sync-dashboard.module').then(m => m.MarkatingDataSyncDashboardModule), canActivate: [AuthGuard] },
  { path: 'marketing-data-reports', loadChildren: () => import('../sales/components/markating-data-sync-reports/markating-data-sync-reports.module').then(m => m.MarkatingDataSyncReportsModule), canActivate: [AuthGuard] },
  { path: 'sms-campaign', loadChildren: () => import('../sales/components/sms-campaign/sms-campaign.module').then(m => m.SmsCampaignModule), canActivate: [AuthGuard] }
];

const entryComponents = [ChangeStatusModalComponent, AssignedToModalComponent, BookAppoinmentModalComponent,
  EmailModalComponent, ScheduleCallbackAddEditModalComponent, SMSModalComponent,
  CustomerCallModalComponent, LeadNoteModalComponent
];
@NgModule({
  declarations: [...entryComponents, SalesDashboardComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    LayoutModule, MatAutocompleteModule,CustomerContactDetailsModule,
    SharedModule, MatCheckboxModule, MatProgressBarModule,
    MatIconModule, MatDialogModule, MatButtonModule, DropdownModule,
    ScrollPanelModule, CalendarModule, MatRadioModule, AngularEditorModule
  ],
  entryComponents: entryComponents,
})
export class SalesModule { }
